import React from "react";
import { Stack, Radio, Title } from "@mantine/core";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {

  const options = ["Sí.", "No."];

  const questions = [
    "La persona afectada debe mostrar rechazo expreso.",
    "La situación debe haber ocurrido más de una vez.",
    "Quien realiza la conducta debe hacerlo con la intención de acosar.",
    "Debe existir una relación de jerarquía entre quien realiza la conducta y quien se ve afectado/a.",
  ];
  const questionIds = ["CPT_001", "CPT_002", "CPT_003", "CPT_004"];

  // Combine questions with their corresponding IDs
  const questionsWithIds = questions.map((question, index) => ({
    question,
    id: questionIds[index],
  }));

  return (
    <>
      <Stack spacing="lg">
        <Title order={3}>Para estar frente a un caso de acoso</Title>
        {questionsWithIds.map(({ question, id }, i) => (
          <React.Fragment key={id}>
            <Radio.Group
              label={question}
              {...form.getInputProps(id)}
              orientation="vertical"
            >
              {options.map((option) => (
                <Radio key={option} value={option} label={option} />
              ))}
            </Radio.Group>
            {/* {i < questionsWithIds.length - 1 && <Divider size="sm" />} */}
          </React.Fragment>
        ))}
      </Stack>
    </>
  );
};

export default Component;
